(function () {
  function isProductGalleryVideo(video) {
    if (!video) return false;

    return Boolean(
      video.closest('.product-media') ||
      video.closest('deferred-media') ||
      video.closest('media-gallery') ||
      video.closest('product-media-gallery') ||
      video.closest('[data-media-gallery]')
    );
  }

  function unmuteVideo(video) {
    if (!video) return;
    if (!isProductGalleryVideo(video)) return;

    video.muted = false;
    video.removeAttribute('muted');

    if (video.volume === 0) {
      video.volume = 1;
    }
  }

  function findVideoInside(container) {
    if (!container) return null;

    let video = container.querySelector && container.querySelector('video');

    if (video) return video;

    const deferredMedia =
      container.closest?.('deferred-media') ||
      container.querySelector?.('deferred-media');

    if (deferredMedia && deferredMedia.shadowRoot) {
      video = deferredMedia.shadowRoot.querySelector('video');
    }

    return video || null;
  }

  function handlePlayButtonClick(event) {
    const button = event.target.closest('.deferred-media__poster-button');

    if (!button) return;

    const media =
      button.closest('.product-media') ||
      button.closest('deferred-media') ||
      button.closest('media-gallery') ||
      button.parentElement;

    let tries = 0;

    const timer = setInterval(function () {
      tries++;

      const video = findVideoInside(media);

      if (video) {
        unmuteVideo(video);
        clearInterval(timer);
      }

      if (tries >= 20) {
        clearInterval(timer);
      }
    }, 50);
  }

  document.addEventListener('click', handlePlayButtonClick, true);

  document.addEventListener(
    'play',
    function (event) {
      const video = event.target;

      if (!video || video.tagName !== 'VIDEO') return;

      unmuteVideo(video);
    },
    true
  );
})();